import React, { ForwardedRef } from 'react';
import { styled } from '@volkswagen-onehub/components-core';
import { ModelSet } from './ModelSet';
import { getTranslations } from '../../translations';

type Props = {
  innerRef?: ForwardedRef<HTMLDivElement>;
}

const AllModelsContainer = styled.div<Props>`
  margin: ${({ theme }) => theme.size.dynamic0150} ${({ theme }) => theme.size.grid002} 0;
`;

const ModelsInner = ({ innerRef }:  Props) => {
  const { labels } = getTranslations();
  return (
    <AllModelsContainer ref={innerRef}>
      <ModelSet header={labels.bus} type="bus"/>
      <ModelSet header={labels.suv} type="suv"/>
      <ModelSet header={labels.compacts} type="compacts"/>
      <ModelSet header={labels.sedans} type="sedans"/>
      <ModelSet header={labels.previous} type="previous"/>
    </AllModelsContainer>
  );
}

export const Models = React.forwardRef<HTMLDivElement, Props>((props, ref) => <ModelsInner innerRef={ref} {...props} />);
